import React, { useEffect } from 'react';

const NOTIFICATION_TYPE = 'force-refresh:bundles';

/**
 * Manages the socket listener for force-refreshing the application bundles.
 *
 * @param {object} socket   The socket for the current scope.
 * @param {string} appName  The application name.
 */
const useForceRefreshBundlesListener = (socket, appName) => {

	/**
	 * Adds real-time socket listener and handler for new force-refresh app bundle notifications.
	 */
	useEffect(() => {

		const handleNotification = (data) => {

			// Check if the force-refresh action is related to this application's bundles
			if (appName && data[appName]) {

				// NOTE: Pass "true" parameter to bypass cache on firefox
				window.location.reload(true);

			}

		};

		socket?.on(NOTIFICATION_TYPE, handleNotification);

		return () => {
			socket?.removeListener(NOTIFICATION_TYPE, handleNotification);
		};

	}, [socket, appName]);

};

export default useForceRefreshBundlesListener;
